
// spaceship演算子
export function spaceship(a, b) {
  if(a < b) return -1
  if(b < a) return 1
  return 0
}

// 配列valuesをプロパティ(複数可)propsで比較してソートする
export function sortByProps(values, ...props) {
  return {...values}.sort((a, b) => {
    for(const prop of props) {
      if(a[prop] < b[prop]) return -1
      if(b[prop] < a[prop]) return 1
    }
    return 0
  })
}
